import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

// @Injectable({ providedIn: 'root' })
// export class FocusService {
//   private lastFocusedElement: HTMLElement | null = null;

//   storeElement(el: HTMLElement): void {
//     this.lastFocusedElement = el;
//   }

//   requestReturnFocus(): void {
//     setTimeout(() => {
//       if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) {
//         this.lastFocusedElement.focus();
//       }
//       this.lastFocusedElement = null;
//     }, 0);
//   }
// }

@Injectable({ providedIn: 'root' })
export class FocusService {
  private lastFocusedElement: HTMLElement | null = null;
  private lastElementSelector: string | null = null;
  private returnFocusSubject = new ReplaySubject<void>(1);
  returnFocus$ = this.returnFocusSubject.asObservable();
  
  storeElement(el: any): void {
    try {
      let candidate: HTMLElement | null = null;

      if (!el) {
        candidate = document.activeElement as HTMLElement | null;
      } else if ((el as any).jquery) {
        candidate = (el as any)[0] as HTMLElement;
      } else if ((el as any).nativeElement) {
        candidate = (el as any).nativeElement as HTMLElement;
      } else if (el instanceof Event) {
        candidate = (el.target as HTMLElement) || (el.currentTarget as HTMLElement) || null;
      } else if ((el as any).nodeType) {
        candidate = el as HTMLElement;
      } else {
        candidate = document.activeElement as HTMLElement | null;
      }

      if (!candidate) {
        return;
      }

      const sentenceAncestor = candidate.closest('[class*="sentence-"]') as HTMLElement | null;
      if (sentenceAncestor) {
        candidate = sentenceAncestor;
      }

      if (!candidate.className || !Array.from(candidate.classList).some(c => c.startsWith('sentence-'))) {
        const sentenceIdAttr = candidate.getAttribute('sentence-id') || candidate.getAttribute('data-sentence-id');
        const dataSource = candidate.getAttribute('data-source-id') || candidate.getAttribute('data-source');
        if (sentenceIdAttr) {
          this.lastElementSelector = `[sentence-id="${sentenceIdAttr}"]`;
        } else if (dataSource) {
          this.lastElementSelector = `[data-source-id="${dataSource}"]`;
        }
      }

      this.lastFocusedElement = candidate;

      if (candidate.id) {
        this.lastElementSelector = `#${candidate.id}`;
      } else if (candidate.className) {
        const sentenceClass = Array.from(candidate.classList).find(c => c.startsWith('sentence-'));
        if (sentenceClass) {
          this.lastElementSelector = `.${sentenceClass}`;
        } else {
          this.lastElementSelector = null;
        }
      } else {
        this.lastElementSelector = null;
      }
    } catch (err) {
      console.error('FocusService.storeElement error', err);
    }
  }
  
  requestReturnFocus(): void {
    let isRestoringFocus = true;
    
    const focusBlocker = (e: FocusEvent) => {
      const target = e.target as HTMLElement;
      if (isRestoringFocus && target && (target.id === 'tabBtn' || target.closest('.sidebar_nav'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };
    
    document.addEventListener('focus', focusBlocker, true);
    
    setTimeout(() => {
      let elementToFocus = this.lastFocusedElement;
      
      if (!elementToFocus || !document.contains(elementToFocus)) {
        if (this.lastElementSelector) {
          elementToFocus = document.querySelector(this.lastElementSelector) as HTMLElement;
        }
      }
      
      if (elementToFocus && document.contains(elementToFocus)) {
        if (document.activeElement && document.activeElement !== elementToFocus) {
          (document.activeElement as HTMLElement).blur();
        }
        
        elementToFocus.focus({ preventScroll: true });
        
        elementToFocus.dispatchEvent(new FocusEvent('focus', { bubbles: true }));
      }
      
      setTimeout(() => {
        isRestoringFocus = false;
        document.removeEventListener('focus', focusBlocker, true);
      }, 50);
      
      this.lastFocusedElement = null;
      this.lastElementSelector = null;
      this.returnFocusSubject.next();
    }, 10);
  }
}

